@import '@hevoio/hevo-ui-toolkit/styles/variables';

.pane {
  display: flex;
  align-items: center;
  padding: $spacer * 0.5 $spacer * 0.75;
  border-radius: $border-radius-md;
  color: $text-default;
  .icon {
    margin-right: $spacer * 0.75;
    margin-top: $spacer * -0.125;
    margin-bottom: $spacer * -0.125;
  }

  .close {
    margin-left: auto;
  }

  &.success {
    background: $success;
    color: $light-text;
    .close {
      color: $light-text;
    }
  }

  &.info {
    background: $info-alert-bg;
    border: $border-width solid $info-alert-border;
  }

  &.info-secondary {
    background: $info-secondary-faded;
    border-color: $info-secondary-border;
  }

  &.info-secondary-1 {
    background: $message-pane-info-1;
    border: $border-width solid $info-secondary-border;
    color: $text-default;
  }

  &.warning {
    background: $warning;
  }

  &.deferred {
    background: $deferred;
  }

  &.error {
    background: $error;
    color: $light-text;
    .close {
      color: $light-text;
    }
  }

  &.secondary {
    background: $secondary-bg;
    border: solid $border-width $divider-color;
  }

  &.success-faded {
    background: $success-faded;
    border: solid $border-width $success-border;
    .icon {
      color: $success;
    }
  }

  &.warning-faded {
    background: $warning-faded;
    border: solid $border-width $warning-border;
    .icon {
      color: $warning;
    }
  }

  &.warning-faded-1 {
    background: $warning-faded-1;
    border: solid $border-width $warning-border;
    .icon {
      color: $warning;
    }
  }

  &.error-faded {
    background: $error-faded;
    border: solid $border-width $error-border;
    .icon {
      color: $error;
    }
  }

  &.error-faded-borderless {
    background: $error-faded-2;
    .icon {
      color: $error;
    }
  }

  &.error-faded-2 {
    background: $error-faded-2;
    color: $error;
    border: solid $border-width $error-border-1;
    .icon {
      color: $error;
    }
  }

  &.info-faded {
    background: $info-faded;
    border: solid $border-width $info-border;
    .icon {
      color: $info;
    }
  }

  &.info-secondary-faded {
    background: $info-secondary-faded;
    border: solid $border-width $info-secondary-border;
  }

  &.info-secondary-faded-2 {
    background: $info-secondary-faded-2;
    border: solid $border-width $info-secondary-faded-2-border;
  }

  &.info-secondary-2 {
    background: $message-pane-info-2;
    color: $white;

    .close {
      color: $light-text;
    }
  }

  &.withoutBorder {
    border-radius: 0;
    border: 0;
    margin-bottom: 0;
  }
}
